export default "__VITE_ASSET___fXu8414__"